// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/stylus/components/_tabs.styl
// module id = 206
// module chunks = 0